import { Badge, Box, IconButton, Input, Spinner, Table } from '@chakra-ui/react';
import { FiCheck } from 'react-icons/fi';
import { getSubjectCellClassName } from './teacherUtils';

export type NewTeacherRowProps = {
  newTeacherName: string;
  setNewTeacherName: (value: string) => void;
  pendingTeacherCreate: boolean;
  pendingTeacherDelete: string | null;
  pendingTeacherRename: string | null;
  pendingSubjectUpdate: string | null;
  subjectColumns: string[];
  handleTeacherCreate: () => void | Promise<void>;
};

export const NewTeacherRow = ({
  newTeacherName,
  setNewTeacherName,
  pendingTeacherCreate,
  pendingTeacherDelete,
  pendingTeacherRename,
  pendingSubjectUpdate,
  subjectColumns,
  handleTeacherCreate,
}: NewTeacherRowProps) => (
  <Table.Row>
    <Table.Cell pl={10}>
      <Box display="flex" alignItems="center" gap={2}>
        <Input
          value={newTeacherName}
          onChange={(event) => setNewTeacherName(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && newTeacherName.trim()) {
              event.preventDefault();
              handleTeacherCreate();
            }
          }}
          placeholder="Dodaj korepetytora"
          variant="flushed"
          size="sm"
        />
        <IconButton
          aria-label="Dodaj korepetytora"
          size="2xs"
          variant="ghost"
          colorPalette="black"
          type="button"
          disabled={pendingTeacherCreate || !!pendingTeacherRename || !!pendingSubjectUpdate || !!pendingTeacherDelete}
          onClick={handleTeacherCreate}
        >
          {pendingTeacherCreate ? <Spinner size="xs" /> : <FiCheck size={14} />}
        </IconButton>
      </Box>
    </Table.Cell>
    <Table.Cell textAlign="center">
      <Badge variant="subtle" colorPalette="gray" size="sm">
        -
      </Badge>
    </Table.Cell>
    {subjectColumns.map((code) => {
      const cellClass = getSubjectCellClassName(code);
      return (
        <Table.Cell key={`new-${code}`} className={cellClass} textAlign="center" px={0} py={0}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            h={7}
            w={7}
            mx="auto"
            borderRadius="sm"
            opacity={0.15}
            color="transparent"
          >
            <FiCheck size={24} />
          </Box>
        </Table.Cell>
      );
    })}
  </Table.Row>
);
